class FFHeroSlideshow extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.slides = [...this.querySelectorAll('[data-ff-slide]')];
    this.dots = [...this.querySelectorAll('[data-ff-slide-button]')];
    this.toggle = this.querySelector('[data-ff-slideshow-toggle]');
    this.index = 0;
    this.timer = null;
    this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.interval = Number(this.dataset.interval) || 5000;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
      this.show(index);
      this.schedule();
    }, options));
    this.toggle?.addEventListener('click', () => {
      this.paused = !this.paused;
      this.syncToggle();
      this.schedule();
    }, options);
    this.addEventListener('mouseenter', () => this.stop(), options);
    this.addEventListener('mouseleave', () => this.schedule(), options);
    this.addEventListener('focusin', () => this.stop(), options);
    this.addEventListener('focusout', () => this.schedule(), options);
    document.addEventListener('visibilitychange', () => this.schedule(), options);
    const stage = this.querySelector('.ff-hero-slides');
    stage?.addEventListener('pointerdown', event => {
      this.touchX = event.clientX;
      this.stop();
    }, options);
    stage?.addEventListener('pointerup', event => {
      const distance = event.clientX - this.touchX;
      if (Math.abs(distance) > 35) this.show(this.index + (distance < 0 ? 1 : -1));
      this.schedule();
    }, options);
    stage?.addEventListener('pointercancel', () => this.schedule(), options);
    this.syncToggle();
    this.schedule();
  }
  syncToggle() {
    if (!this.toggle) return;
    this.toggle.setAttribute('aria-pressed', String(this.paused));
    this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
  }
  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
      slide.setAttribute('aria-hidden', String(i !== this.index));
    });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
  }
  stop() {
    clearTimeout(this.timer);
    this.timer = null;
  }
  schedule() {
    this.stop();
    if (this.paused || this.slides.length < 2 || document.hidden) return;
    this.timer = setTimeout(() => {
      this.show(this.index + 1);
      this.schedule();
    }, this.interval);
  }
  disconnectedCallback() {
    this.stop();
    this.events?.abort();
    this.ready = false;
  }
}
if (!customElements.get('ff-hero-slideshow')) customElements.define('ff-hero-slideshow', FFHeroSlideshow);
